export enum DeviceType {
  Mobile = 'Mobile',
  Desktop = 'Desktop',
}

export function detectDevice(): DeviceType {
  const userAgent = navigator.userAgent;

  if (/android|iPhone|iPad|iPod|blackberry|windows phone|opera mini|mobile/i.test(userAgent.toLowerCase())) {
    return DeviceType.Mobile;
  } else {
    return DeviceType.Desktop;
  }
}

export function isWebGLSupported() {
  try {
    const canvas = document.createElement('canvas');
    return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
  } catch (e) {
    return false;
  }
}

export function supportsES2020() {
  try {
    // Test ES2020 features
    new Function(`
	  let foo = {}?.bar; 
	  let baz = 1 ?? 2; 
	  import('').catch(() => {}); 
	  BigInt(123);
	  globalThis;
	`)();
    return true; // If execution reaches here, ES2020 is supported
  } catch (e) {
    return false; // If error occurs, ES2020 is not supported
  }
}
